import { Decimal } from 'decimal.js';

export function convertFromToAmount(
  amount: number | string,
  rate: number | string,
  decimals = 2,
): string {
  return convertAmount(amount, rate, decimals, Decimal.ROUND_DOWN);
}

export function convertToFromAmount(
  amount: number | string,
  rate: number | string,
  decimals = 2,
): string {
  return convertAmount(amount, 1 / +rate, decimals, Decimal.ROUND_UP);
}

export function convertAmount(
  amount: number | string,
  rate: number | string,
  decimals: number,
  rounding: Decimal.Rounding,
): string {
  if (!Number(amount) || !Number(rate)) return '0';

  return new Decimal(amount)
    .times(rate)
    .toDecimalPlaces(decimals, rounding)
    .toFixed(decimals);
}
